export const options = {
    TODAY: "today",
    RANGE: "range",
    YEAR: "year",
};

export const exportOptions = {
    SIE4I: {
        title: "exportToSie4",
        description: ".si",
        enumCode: 3,
    },
    SIE5: {
        title: "exportToSie5",
        description: ".sie",
        enumCode: 4,
    },
    EXCEL: {
        title: "exportToExcel",
        description: ".xlsx",
        enumCode: 1,
        group: "accountingReport",
    },
    CSV: {
        title: "exportToCommaSeparated",
        description: ".csv",
        enumCode: 2,
        group: "accountingReport",
    },
    CAMT054: {
        title: "exportToCamt054",
        description: ".xml",
        enumCode: 5,
        group: "referencePaymentReport",
    },
    KTL: {
        title: "exportToKtl",
        description: ".txt",
        enumCode: 6,
        group: "referencePaymentReport",
    },
};
